import { useInitLanguageUrl } from 'src/modules/locales/hooks/useInitLanguageUrl';
import { useAddGtmEffect, useGetUserCountry, useTrackReferralLink } from 'react-easyrocket';
import { useTrackIncomingBonusTransaction } from 'src/hooks/useTrackIncomingBonusTransaction';
import { useInitDepositMethods } from 'src/hooks/useInitDepositMethods';
import { useSmartlookIdentify } from 'src/utils/smartlook/useSmartlookIdentify';
import { useCentrifugeMessages } from 'src/hooks/useCentrifugeMessages';
import { useOnesignal } from 'react-easyrocket/onesignal';
import { ONESIGNAL_APP_ID } from 'src/constants/oneSignal';
import { isDev, isProductionEnv } from 'src/api';
import { useOpenEventModal } from 'src/hooks/useOpenEventModal';
import { useDoSomethingOnLogout } from 'src/hooks/useDoSomethingOnLogout';
import { useSetSmarticoUser } from 'src/hooks/useSetSmarticoUser';
import { useSetUserDataToLiveChat } from 'src/hooks/useSetUserDataToLiveChat';
import { useTrackLinkAction } from 'src/hooks/useTrackLinkAction';
import { useAccountSearchParam } from 'src/hooks/useAccountSearchParam';
import { useCacheSession } from 'src/hooks/useCacheSession';
import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { useInitWindowSizeStore } from 'src/modules/store/windowSizeStore';
import { useAuthFlowSuccessCallback } from 'src/modules/authFlow/hooks/useAuthFlowSuccessCallback';
import { useJackpotWin } from 'src/modals/JackpotWinModal/hooks/useJackpotWin';
import { useRemoveQueriesOnLogout } from '../hooks/useRemoveQueriesOnLogout';
import { useClearSignUpCache } from 'src/modals/SignupModal/hooks/useClearSignUpCache';
import { useSaveEmailFromQuery } from 'src/hooks/useSaveEmailFromQuery';
import { useGPTStateReset } from 'src/EXPERIMENTAL_LIB/gpt/games/hooks/useGPTStateReset';
import { useCio } from 'src/modules/cio';

export const DoSomethingOnEveryPage = () => {
  const { pathname } = useLocation();
  const { refetch: refetchUserCountry } = useGetUserCountry();
  useSaveEmailFromQuery();
  useJackpotWin();
  useGPTStateReset();
  useAccountSearchParam();
  useCio();
  useCacheSession();
  useInitLanguageUrl();
  useOpenEventModal();
  useInitDepositMethods();
  useSetUserDataToLiveChat();
  useAddGtmEffect();
  useTrackReferralLink();
  useTrackIncomingBonusTransaction();
  useSetSmarticoUser();
  useDoSomethingOnLogout();
  useSmartlookIdentify();
  useTrackLinkAction();
  useClearSignUpCache();
  useEffect(() => {
    refetchUserCountry();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  useOnesignal({
    config: { appId: ONESIGNAL_APP_ID },
    isEnabled: isProductionEnv && !isDev,
    debug: false
  });
  useCentrifugeMessages();
  useAuthFlowSuccessCallback();
  useInitWindowSizeStore();
  useRemoveQueriesOnLogout();
  return null;
};
